import { render, staticRenderFns } from "./viewForm.vue?vue&type=template&id=7bc61a05&scoped=true&"
import script from "./viewForm.vue?vue&type=script&lang=js&"
export * from "./viewForm.vue?vue&type=script&lang=js&"
import style0 from "./viewForm.vue?vue&type=style&index=0&id=7bc61a05&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc61a05",
  null
  
)

export default component.exports